import DashboardIndex from '@/components/dashboard/dashboard-index.vue';
import { createMemoryHistory, createRouter } from 'vue-router'
import ListCategory from '@/components/category/list-category.vue';
import ListSupplier from '@/components/supplier/list-supplier.vue';
import ListUser from '@/components/user/list-user.vue';
import NewCategory from '@/components//category/new-category.vue';
import AuthLogin from '@/components/authentication/auth-login.vue';
import EditCategory from '@/components/category/edit-category.vue';
import ListService from '@/components/service/list-service.vue';
import NewService from '@/components/service/new-service.vue';
import EditService from '@/components/service/edit-service.vue';
import NewSupplier from '@/components/supplier/new-supplier.vue';
import EditSupplier from '@/components/supplier/edit-supplier.vue';
import EditSupplierAddress from '@/components/supplier/edit-supplier-address.vue';
import EditSupplierFiscal from '@/components/supplier/edit-supplier-fiscal.vue';
import ListClient from '../components/client/list-client.vue';
import EditClientFiscal from '@/components/client/edit-client-fiscal.vue';
import EditClientAccess from '@/components/client/edit-client-access.vue';
import EditClientService from '@/components/client/edit-client-service.vue';
import EditClientStatusService from '@/components/client/edit-client-status-service.vue';
import EditClientFile from '@/components/client/edit-client-file.vue';
import NewClientPf from '@/components/client/new-client-pf.vue';
import NewClientPj from '@/components/client/new-client-pj.vue';
import EditClientPf from '@/components/client/edit-client-pf.vue';
import EditClientPj from '@/components/client/edit-client-pj.vue';
import EditClientManagingPartner from '@/components/client/edit-client-managing-partner.vue';
import NewUser from '@/components/user/new-user.vue';
import EditUser from '@/components/user/edit-user.vue';
import ListRole from '@/components/role/list-role.vue';
import NewRole from '@/components/role/new-role.vue';
import EditRole from '@/components/role/edit-role.vue';
import ListPermissionRole from '@/components/role/list-permission-role.vue';
import ListLead from '@/components/lead/list-lead.vue';
import NewLead from '@/components/lead/new-lead.vue';
import EditLead from '@/components/lead/edit-lead.vue';
import EditClientStructureCorporate from '@/components/client/edit-client-structure-corporate.vue';
import ListLog from '@/components/log/list-log.vue';
import ResetPasswordTemporary from '@/components/user/reset-password-temporary.vue';
import ListActivity from '@/components/activity/list-activity.vue';
import DashboardActivity from '@/components/activity/dashboard-activity.vue';
import LinkUser from '@/components/user/link-user.vue';
import EditClientCertificate from '@/components/client/edit-client-certificate.vue';
import ListBankAccount from '@/components/bank-account/list-bank-account.vue';
import NewBankAccount from '@/components/bank-account/new-bank-account.vue';
import EditBankAccount from '@/components/bank-account/edit-bank-account.vue';
import EditBankAccountGateway from '@/components/bank-account/edit-bank-account-gateway.vue';
import authMiddleware from '@/middleware/auth';
import changePasswordTemporary from '@/middleware/passwordTemporary';
import twoAuthenticationFactorFilter from '@/middleware/twoAuthenticationFactorFilter';
import ListNotification from '@/components/notification/list-notification.vue';
import ListClientAccess from '@/components/client/list-client-access.vue';
import EditClientFileOffice from '@/components/client/edit-client-file-office.vue';
import TwoAuthenticationFactor from '@/components/user/two-authentication-factor.vue';
import ListReceivableAccount from '@/components/receivable-account/list-receivable-account.vue';
import NewReceivableAccount from '@/components/receivable-account/new-receivable-account.vue';
import ResetPassword from '@/components/authentication/reset-password.vue';
import MirrorDirectory from '@/components/setting/mirror-directory.vue';
import GeneralConfiguration from '@/components/setting/general-configuration.vue';
import ListPayableAccount from '@/components/payable-account/list-payable-account.vue';
import NewPayableAccount from '@/components/payable-account/new-payable-account.vue';
import DashboardFinancial from '@/components/dashboard/dashboard-financial.vue';


const routes = [

  { path: '/login', component: AuthLogin, meta: { hideMenu: true } },
  { path: '/resetPassword', component: ResetPassword, meta: { hideMenu: true } },
  { path: '/', component: DashboardIndex, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },


  /**Categorias */
  { path: '/category', component: ListCategory, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/category/new', component: NewCategory, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/category/:id', component: EditCategory, name: "category_edit" },

  /**Serviços */
  { path: '/service', component: ListService, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/service/new', component: NewService, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/service/:id', component: EditService, name: "service_edit" },

  /**Fornecedores */
  { path: '/supplier', component: ListSupplier, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/supplier/new', component: NewSupplier, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/supplier/:id', component: EditSupplier, name: "supplier_edit", meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/supplier/:id/address', component: EditSupplierAddress, name: "supplier_address_edit", meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/supplier/:id/fiscal', component: EditSupplierFiscal, name: "supplier_fiscal_edit", meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },


  /**Clientes */
  { path: '/client', component: ListClient, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/client/new/pf', component: NewClientPf, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/client/new/pj', component: NewClientPj, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/client/:id', component: EditClientPf, name: "client_pf_edit", meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/client/:id', component: EditClientPj, name: "client_pj_edit", meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/client/:id/managingPartner', component: EditClientManagingPartner, name: "client_managing_partner", meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/client/:id/fiscal', component: EditClientFiscal, name: "client_fiscal_edit", meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/client/:id/access', component: EditClientAccess, name: "client_access_edit", meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/client/:id/service', component: EditClientService, name: "client_service_edit", meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/client/:id/status', component: EditClientStatusService, name: "client_status_edit", meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/client/:id/file', component: EditClientFile, name: "client_file_edit", meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/client/:id/fileOffice', component: EditClientFileOffice, name: "client_file_office_edit", meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/client/:id/structureCorporate', component: EditClientStructureCorporate, name: "client_structure_corporate_edit", meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/client/:id/certificate', component: EditClientCertificate, name: "client_certificate_edit", meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/client/:id/accessSystem', component: ListClientAccess, name: "client_access_system", meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },

  /**Leads */
  { path: '/lead', component: ListLead, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/lead/new', component: NewLead, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/lead/:id', component: EditLead, name: "lead_edit" },

  /**Contas bancárias */
  { path: '/bank-account', component: ListBankAccount, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/bank-account/new', component: NewBankAccount, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/bank-account/:id', component: EditBankAccount, name: "bank_account_edit" },
  { path: '/bank-account/:id/gateway', component: EditBankAccountGateway, name: "bank_account_gateway_edit" },

  /**Contas a receber */
  { path: '/receivable-account', component: ListReceivableAccount, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/receivable-account/new', component: NewReceivableAccount, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },

  /**Contas a pagar */
  { path: '/payable-account', component: ListPayableAccount, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/payable-account/new', component: NewPayableAccount, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },

  /***Dashboard Financeiro */
  { path: '/dashboard-financial', component: DashboardFinancial, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },

  /**Usuários */
  { path: '/user', component: ListUser, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/user/new', component: NewUser, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/user/:id', component: EditUser, name: "user_edit" },
  { path: '/user/:id/activity', component: LinkUser, name: "user_activity" },

  /**Perfis de acesso */
  { path: '/role', component: ListRole, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/role/new', component: NewRole, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/role/:id', component: EditRole, name: "role_edit" },
  { path: '/role/:id/permission', component: ListPermissionRole, name: "permission_role", meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },

  /**Logs */
  { path: '/log', component: ListLog, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },

  //Diretórios espelho
  { path: '/mirror-directory', component: MirrorDirectory, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },

  //Atividades
  { path: '/activity', component: ListActivity, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },
  { path: '/activity-statistic', component: DashboardActivity, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } },


  //Redefinir senha temporária
  { path: '/change-password-temporary', component: ResetPasswordTemporary, meta: { requiresAuth: true, hideMenu: true } },

  //Validar 2FA
  { path: '/two-authentication-factor', component: TwoAuthenticationFactor, meta: { requiresAuth: true, hideMenu: true } },

  //Notificações
  { path: '/notification-user', component: ListNotification, meta: { requiresAuth: true } },

  //Configurações
  { path: '/general-configuration', component: GeneralConfiguration, meta: { requiresAuth: true, resetPasswordTemporary: true, twoAuthenticationFactor: true } }

];

const router = createRouter({ history: createMemoryHistory(), routes });

router.beforeEach(async (to, from, next) => { await authMiddleware(to, from, next); });

router.beforeEach(async (to, from, next) => { await changePasswordTemporary(to, from, next); });

router.beforeEach(async (to, from, next) => { await twoAuthenticationFactorFilter(to, from, next); });




export default router;